/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddonProvisionProject200Response,
    AddonProvisionProject200ResponseFromJSON,
    AddonProvisionProject200ResponseToJSON,
} from '../models/AddonProvisionProject200Response';
import {
    type AddonProvisionProjectRequest,
    AddonProvisionProjectRequestFromJSON,
    AddonProvisionProjectRequestToJSON,
} from '../models/AddonProvisionProjectRequest';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type ShoptetAddonOpen400Response,
    ShoptetAddonOpen400ResponseFromJSON,
    ShoptetAddonOpen400ResponseToJSON,
} from '../models/ShoptetAddonOpen400Response';
import {
    type ShoptetAddonOpen403Response,
    ShoptetAddonOpen403ResponseFromJSON,
    ShoptetAddonOpen403ResponseToJSON,
} from '../models/ShoptetAddonOpen403Response';
import {
    type ShoptetWebhookRequest,
    ShoptetWebhookRequestFromJSON,
    ShoptetWebhookRequestToJSON,
} from '../models/ShoptetWebhookRequest';
import {
    type UpgatesAddonInstall200Response,
    UpgatesAddonInstall200ResponseFromJSON,
    UpgatesAddonInstall200ResponseToJSON,
} from '../models/UpgatesAddonInstall200Response';
import {
    type UpgatesAddonInstallRequest,
    UpgatesAddonInstallRequestFromJSON,
    UpgatesAddonInstallRequestToJSON,
} from '../models/UpgatesAddonInstallRequest';
import {
    type UpgatesAddonOpen200Response,
    UpgatesAddonOpen200ResponseFromJSON,
    UpgatesAddonOpen200ResponseToJSON,
} from '../models/UpgatesAddonOpen200Response';
import {
    type UpgatesAddonOpenRequest,
    UpgatesAddonOpenRequestFromJSON,
    UpgatesAddonOpenRequestToJSON,
} from '../models/UpgatesAddonOpenRequest';
import {
    type UpgatesAddonProvisionProjectRequest,
    UpgatesAddonProvisionProjectRequestFromJSON,
    UpgatesAddonProvisionProjectRequestToJSON,
} from '../models/UpgatesAddonProvisionProjectRequest';
import {
    type UpgatesAddonUninstallRequest,
    UpgatesAddonUninstallRequestFromJSON,
    UpgatesAddonUninstallRequestToJSON,
} from '../models/UpgatesAddonUninstallRequest';
import {
    type UpgatesWebhookRequest,
    UpgatesWebhookRequestFromJSON,
    UpgatesWebhookRequestToJSON,
} from '../models/UpgatesWebhookRequest';

export interface IntegrationsApiAddonProvisionProjectOperationRequest {
    addonProvisionProjectRequest?: AddonProvisionProjectRequest;
}

export interface IntegrationsApiShoptetAddonInstallRequest {
    code: string;
}

export interface IntegrationsApiShoptetAddonOpenRequest {
    eshopId: number;
    code: string;
    language?: string;
}

export interface IntegrationsApiShoptetAddonUserVerificationRequest {
    code?: string;
    state?: string;
    eshopId?: number;
}

export interface IntegrationsApiShoptetWebhookOperationRequest {
    shoptetWebhookRequest?: ShoptetWebhookRequest;
}

export interface IntegrationsApiUpgatesAddonInstallOperationRequest {
    upgatesAddonInstallRequest?: UpgatesAddonInstallRequest;
}

export interface IntegrationsApiUpgatesAddonOpenOperationRequest {
    upgatesAddonOpenRequest?: UpgatesAddonOpenRequest;
}

export interface IntegrationsApiUpgatesAddonProvisionProjectOperationRequest {
    upgatesAddonProvisionProjectRequest?: UpgatesAddonProvisionProjectRequest;
}

export interface IntegrationsApiUpgatesAddonUninstallOperationRequest {
    upgatesAddonUninstallRequest?: UpgatesAddonUninstallRequest;
}

export interface IntegrationsApiUpgatesAddonVersionRequest {
    upgatesAddonUninstallRequest?: UpgatesAddonUninstallRequest;
}

export interface IntegrationsApiUpgatesWebhookOperationRequest {
    upgatesWebhookRequest?: UpgatesWebhookRequest;
}

/**
 * 
 */
export class IntegrationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for addonProvisionProject without sending the request
     */
    async addonProvisionProjectRequestOpts(requestParameters: IntegrationsApiAddonProvisionProjectOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/provision-project`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddonProvisionProjectRequestToJSON(requestParameters['addonProvisionProjectRequest']),
        };
    }

    /**
     */
    async addonProvisionProjectRaw(requestParameters: IntegrationsApiAddonProvisionProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddonProvisionProject200Response>> {
        const requestOptions = await this.addonProvisionProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddonProvisionProject200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async addonProvisionProject(requestParameters: IntegrationsApiAddonProvisionProjectOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddonProvisionProject200Response> {
        const response = await this.addonProvisionProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shoptetAddonInstall without sending the request
     */
    async shoptetAddonInstallRequestOpts(requestParameters: IntegrationsApiShoptetAddonInstallRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling shoptetAddonInstall().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/addon/shoptet/install`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async shoptetAddonInstallRaw(requestParameters: IntegrationsApiShoptetAddonInstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shoptetAddonInstallRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shoptetAddonInstall(requestParameters: IntegrationsApiShoptetAddonInstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shoptetAddonInstallRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for shoptetAddonOpen without sending the request
     */
    async shoptetAddonOpenRequestOpts(requestParameters: IntegrationsApiShoptetAddonOpenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['eshopId'] == null) {
            throw new runtime.RequiredError(
                'eshopId',
                'Required parameter "eshopId" was null or undefined when calling shoptetAddonOpen().'
            );
        }

        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling shoptetAddonOpen().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['eshopId'] != null) {
            queryParameters['eshopId'] = requestParameters['eshopId'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/addon/shoptet/open`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async shoptetAddonOpenRaw(requestParameters: IntegrationsApiShoptetAddonOpenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shoptetAddonOpenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shoptetAddonOpen(requestParameters: IntegrationsApiShoptetAddonOpenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shoptetAddonOpenRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for shoptetAddonUserVerification without sending the request
     */
    async shoptetAddonUserVerificationRequestOpts(requestParameters: IntegrationsApiShoptetAddonUserVerificationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['eshopId'] != null) {
            queryParameters['eshopId'] = requestParameters['eshopId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/addon/shoptet/user-verification`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async shoptetAddonUserVerificationRaw(requestParameters: IntegrationsApiShoptetAddonUserVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shoptetAddonUserVerificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shoptetAddonUserVerification(requestParameters: IntegrationsApiShoptetAddonUserVerificationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shoptetAddonUserVerificationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for shoptetWebhook without sending the request
     */
    async shoptetWebhookRequestOpts(requestParameters: IntegrationsApiShoptetWebhookOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/shoptet/webhook`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShoptetWebhookRequestToJSON(requestParameters['shoptetWebhookRequest']),
        };
    }

    /**
     */
    async shoptetWebhookRaw(requestParameters: IntegrationsApiShoptetWebhookOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shoptetWebhookRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shoptetWebhook(requestParameters: IntegrationsApiShoptetWebhookOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shoptetWebhookRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for upgatesAddonInstall without sending the request
     */
    async upgatesAddonInstallRequestOpts(requestParameters: IntegrationsApiUpgatesAddonInstallOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/install`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonInstallRequestToJSON(requestParameters['upgatesAddonInstallRequest']),
        };
    }

    /**
     */
    async upgatesAddonInstallRaw(requestParameters: IntegrationsApiUpgatesAddonInstallOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesAddonInstall200Response>> {
        const requestOptions = await this.upgatesAddonInstallRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesAddonInstall200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async upgatesAddonInstall(requestParameters: IntegrationsApiUpgatesAddonInstallOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesAddonInstall200Response> {
        const response = await this.upgatesAddonInstallRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesAddonOpen without sending the request
     */
    async upgatesAddonOpenRequestOpts(requestParameters: IntegrationsApiUpgatesAddonOpenOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/open`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonOpenRequestToJSON(requestParameters['upgatesAddonOpenRequest']),
        };
    }

    /**
     */
    async upgatesAddonOpenRaw(requestParameters: IntegrationsApiUpgatesAddonOpenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesAddonOpen200Response>> {
        const requestOptions = await this.upgatesAddonOpenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesAddonOpen200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async upgatesAddonOpen(requestParameters: IntegrationsApiUpgatesAddonOpenOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesAddonOpen200Response> {
        const response = await this.upgatesAddonOpenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesAddonProvisionProject without sending the request
     */
    async upgatesAddonProvisionProjectRequestOpts(requestParameters: IntegrationsApiUpgatesAddonProvisionProjectOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/provision-project`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonProvisionProjectRequestToJSON(requestParameters['upgatesAddonProvisionProjectRequest']),
        };
    }

    /**
     * Creates or assigns a project to the Upgates addon. If the addon already has a project, does nothing. Called from the UI after login/onboarding.
     */
    async upgatesAddonProvisionProjectRaw(requestParameters: IntegrationsApiUpgatesAddonProvisionProjectOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddonProvisionProject200Response>> {
        const requestOptions = await this.upgatesAddonProvisionProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddonProvisionProject200ResponseFromJSON(jsonValue));
    }

    /**
     * Creates or assigns a project to the Upgates addon. If the addon already has a project, does nothing. Called from the UI after login/onboarding.
     */
    async upgatesAddonProvisionProject(requestParameters: IntegrationsApiUpgatesAddonProvisionProjectOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddonProvisionProject200Response> {
        const response = await this.upgatesAddonProvisionProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesAddonUninstall without sending the request
     */
    async upgatesAddonUninstallRequestOpts(requestParameters: IntegrationsApiUpgatesAddonUninstallOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/uninstall`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonUninstallRequestToJSON(requestParameters['upgatesAddonUninstallRequest']),
        };
    }

    /**
     */
    async upgatesAddonUninstallRaw(requestParameters: IntegrationsApiUpgatesAddonUninstallOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.upgatesAddonUninstallRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upgatesAddonUninstall(requestParameters: IntegrationsApiUpgatesAddonUninstallOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upgatesAddonUninstallRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for upgatesAddonVersion without sending the request
     */
    async upgatesAddonVersionRequestOpts(requestParameters: IntegrationsApiUpgatesAddonVersionRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/version`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesAddonUninstallRequestToJSON(requestParameters['upgatesAddonUninstallRequest']),
        };
    }

    /**
     */
    async upgatesAddonVersionRaw(requestParameters: IntegrationsApiUpgatesAddonVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesAddonInstall200Response>> {
        const requestOptions = await this.upgatesAddonVersionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesAddonInstall200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async upgatesAddonVersion(requestParameters: IntegrationsApiUpgatesAddonVersionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesAddonInstall200Response> {
        const response = await this.upgatesAddonVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesWebhook without sending the request
     */
    async upgatesWebhookRequestOpts(requestParameters: IntegrationsApiUpgatesWebhookOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/integration/addon/upgates/webhook`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesWebhookRequestToJSON(requestParameters['upgatesWebhookRequest']),
        };
    }

    /**
     */
    async upgatesWebhookRaw(requestParameters: IntegrationsApiUpgatesWebhookOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.upgatesWebhookRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upgatesWebhook(requestParameters: IntegrationsApiUpgatesWebhookOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upgatesWebhookRaw(requestParameters, initOverrides);
    }

}
